import { useCallback } from 'react';
import { QueryResult, useQuery, useMutation, ApolloError } from '@apollo/client';
import type { Tour, TourStep } from '../../schema-generated-types-educator';
import GET_TOURS from '../../queries/tour/get-tours-query';
import SAVE_TOUR_SETTING from '../../queries/tour/save-tour-setting';
import { TourName } from '../../../types';

export type TourStoreState = {
  tourData?: Tour;
  tourSteps?: TourStep[];
  loading: boolean;
  error?: ApolloError;
};

export type TourStoreDispatch = {
  handleSaveTourSetting: (data: any) => void;
};

export type TourStore = [TourStoreState, TourStoreDispatch];

const useTourStore = (tourName: TourName, appName?: string): TourStore => {
  const { data, loading, error }: QueryResult = useQuery(GET_TOURS, {
    variables: { where: { appName } },
  });
  const [saveTourSetting] = useMutation(SAVE_TOUR_SETTING);

  const handleSaveTourSetting = useCallback(async (data) => {
    try {
      await saveTourSetting({
        variables: { data },
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  const tours = data?.tours;
  const tour = tours?.find((tour) => tour.name === tourName);
  return [
    {
      tourData: tour,
      tourSteps: tour?.tourSteps,
      loading,
      error,
    },
    {
      handleSaveTourSetting,
    },
  ];
};

export default useTourStore;
